import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';


import { SelectNgoService } from './select-ngo.service';

declare var $: any;
declare var swal: any;


@Component({
  selector: 'select-ngo',
  templateUrl: './select-ngo.component.html',
  styleUrls: ['./select-ngo.component.css']
})
export class SelectNgoComponent implements OnInit {

  @Input() type: string = "all"; //all (traz as dua abas ngo+causes), ngo(traz só ongs) ou causes(traz só causas)
  @Input() maxCause: number = 3;
  @Input() needJuno: boolean = true;
  @Input() isAdmin: boolean = false;
  @Input() canChange: boolean = true;
  @Input() category: string | null;
  @Input() maxShow: number = 15;

  @Output() answer = new EventEmitter();


  filtesCauses: any;
  selectedNgos: Array<string>;
  ngosList: any = null;
  causesList: any = null;
  totalPages: Array<number>;
  actualPage: number;
  isCheck: boolean = false;
  loading: boolean = false;
  showError: boolean = false;

  //Filtros
  filterCategory: string = "";
  filterState: string = "";
  filterName: string = "";

  constructor(public selectNgoService: SelectNgoService) { }

  ngOnInit(): void {
    debugger;
    this.loading = true;
    let obj = this;
    //console.log("Componente Selector");
    //console.log(this.isAdmin);
    this.selectedNgos = new Array();
    this.loadMultipleSources().subscribe(([filtesCauses]) => {
      debugger
      this.filtesCauses = filtesCauses;
      if(this.type == 'causes'){
        this.causesList = filtesCauses;
      }else{
        if(this.category != null)
          this.filterCategory = this.category;
        this.ngosList = this.filteredOngs(0);
      }
      this.showError = filtesCauses == null || filtesCauses.length == 0;
      this.loading = false;
    })
  }

  loadMultipleSources(): Observable<any[]> {
    let filtesCauses = this.selectNgoService.getCauses();
    return forkJoin([filtesCauses]);
  }

  selectNgo(ngo) {
    if (this.selectedNgos.indexOf(ngo.ngoId) < 0) {
      if (this.selectedNgos.length < this.maxCause || this.isAdmin) {
        this.selectedNgos.push(ngo.ngoId);
        ngo.selected = true;
      } else {
        ngo.selected = false;
        swal({
          title: 'OPS!',
          html: "Você pode escolher um máximo de " + this.maxCause + " organizações para apoiar. Você já apoia: <b> Desative uma das selecionadas para alterar.",
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          reverseButtons: true
        }).then((result) => {

        })
      }
    } else {
      this.selectedNgos = this.selectedNgos.filter((x) => { return x !== ngo.ngoId });
      ngo.selected = false;
    }
    this.answer.emit({
      "selectedCauses": this.selectedNgos,
    });
    // //console.log(this.selectedNgos);
  }

  selectCause(ngo){
    if (this.selectedNgos.indexOf(ngo.friendlyUrl) < 0) {
      if (this.selectedNgos.length < this.maxCause || this.isAdmin) {
        this.selectedNgos.push(ngo.friendlyUrl);
        ngo.selected = true;
      } else {
        ngo.selected = false;
        swal({
          title: 'OPS!',
          html: "Você pode escolher um máximo de " + this.maxCause + " organizações para apoiar. Você já apoia: <b> Desative uma das selecionadas para alterar.",
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          reverseButtons: true
        }).then((result) => {

        })
      }
    } else {
      this.selectedNgos = this.selectedNgos.filter((x) => { return x !== ngo.friendlyUrl });
      ngo.selected = false;
    }
    this.answer.emit({
      "selectedCauses": this.selectedNgos,
    });
    // //console.log(this.selectedNgos);
  }
  
  //#region Filters
  changeFilterCategory(category: string) {
    this.filterCategory = category;
    this.filteredOngs(0);
  }

  changeFilterState(event) {
    this.filterState = event.target.value;
    this.filteredOngs(0);
  }

  changeFilterName(event) {
    let term = event.target.value;
    if (term == "" || term.length >= 3) {
      this.filterName = term;
      this.filteredOngs(0);
    }
  }

  filteredOngs(page: number | null) {
    let obj = this;
    this.actualPage = page;
    this.selectNgoService.searchNgos(true, true, this.needJuno, this.filterName, this.filterState, this.filterCategory, page, this.maxShow).subscribe(data => {
      if (data.success) {
        data.data.results.forEach(ngo => {
          ngo.selected = obj.isChecked(ngo.ngoId);
        });
        this.ngosList = data.data.results;
        this.showError = data.data.results == null || data.data.results == 0;
        this.totalPages = new Array(data.totalPages).map((x, i) => i);
      }
    });
  }

  isChecked(id:string){
    if(this.selectedNgos != null){
      if (this.selectedNgos.indexOf(id) > -1) {
        return true;
      }else{
        return false;
      }
    }
  }
  //#endregion


}
